(function(){
	'use strict';
	angular.module('app.leanProjects')
		.service('newProjectService', newProjectService);
	
	newProjectService.$inject = ['$http', 'hostUrl', 'leanFilterService'];
	function newProjectService($http, hostUrl, leanFilterService) {
		return {
			saveProject: saveProject,
			getFilterData: getFilterData,
			getTemplates: getTemplates,
			getUsers: getUsers,
			filterUsers: filterUsers
		};
				
		function saveProject(project, leanDirFactoryNdx, templateNdx, metricNdx) {
			var queryParams = {};
			var url = hostUrl + '2/factndx/' + leanDirFactoryNdx + '/LeanProject';
			if (templateNdx > -1) queryParams['template'] = templateNdx;
			if (metricNdx) queryParams['metricNdx'] = metricNdx;

			url = addQueryParam(url, null, queryParams, false);
			return $http.post(url, project)
				.then(saveProjectSuccess)
				.catch(saveProjectFailed);
			
			function saveProjectSuccess(response) {
				return 'Project created successfully';
			}
			
			function saveProjectFailed(error) {
				return 'Unknown server error';
			}
		}
		
		function getUsers(leanDirFactoryNdx, inactiveUserNdx, excludeSuppliers) {
			var url = '2/factndx/' + leanDirFactoryNdx + '/Actions/Users' +
				(inactiveUserNdx ? '?inactiveUserNdx=' + inactiveUserNdx : '');

			if (excludeSuppliers) {
				var parts = url.split('?');
				var qParams = '';
				if (parts.length > 1) {
					qParams = '?' + parts[1];
				}
				qParams = appendQueryParam(qParams, 'excludeSuppliers', excludeSuppliers);
				url = parts[0] + qParams;
			}

			return $http.get(hostUrl + url)
				.then(getUsersDataSuccess)
				.catch(getUsersDataError);
			
			function getUsersDataSuccess(response) {
				return response.data.map(function(user) {
					return { 'name': user.firstName + ' ' + user.lastName, 'id': user.ndx };
				});
			}
			
			function getUsersDataError() {
				return [];
			}
		}

		function getFilterData(filterName, variableName, factoryId) {
			factoryId = factoryId || globalConfig.factory.id;
			var filter = leanFilterService.getFilterByDefinitionName(filterName);
			var filterUrl;
			if (filter.updateOnFactory) {
				filterUrl = String.format(filter.unformattedUrl, factoryId);
			} else {
				filterUrl = leanFilterService.getFilterByDefinitionName(filterName).url;
			}
			if (filter.id === 'projectArea') {
				var parts = filterUrl.split('?');
				var qParams = '';
				if (parts.length > 1) {
					qParams = '?' + parts[1];
				}
				qParams = appendQueryParam(qParams, 'allFactoryArea', true);
				filterUrl = parts[0] + qParams;
			}
			return $http.get(hostUrl + filterUrl)
				.then(getFilterDataSuccess)
				.catch(getFilterDataFailed);
			
			function getFilterDataSuccess(response) {
				return {'id':filter.id, 'data':response.data, 'variableName':variableName};
			}
			
			function getFilterDataFailed(error) {
				return {'id':filter.id, 'data': [], 'variableName':variableName};
			}
		}
		
		function getTemplates(leanDirFactoryNdx) {
			var url = hostUrl + '2/factndx/' + leanDirFactoryNdx + '/LeanProject/Templates?showCrossSite=true';
			return $http.get(url)
				.then(getTemplatesSuccess)
				.catch(getTemplatesFailed);
			
			function getTemplatesSuccess(response) {
				return response.data;
			}
			
			function getTemplatesFailed(error) {
				return [];
			}
		}

		function filterUsers(usersList, searchTerm) {
			if (searchTerm == '') {
				return usersList;
			} else {
				var filteredResults = [];
				angular.forEach(usersList, function(item) {
					if( item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0 ) {
						filteredResults.push(item);
					}
				});

				return filteredResults;
			}
		}
	}
})();
